export class ModuleConnectionAdapter {
    #box;
    constructor(_context, box) {
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get source() { return this.#box.source.targetVertex.unwrap("Insufficient Vertex"); }
    get target() { return this.#box.target.targetVertex.unwrap("Insufficient Vertex"); }
    terminate() { }
}
